import * as React from 'react';
import { InfoWindow, Marker } from '@react-google-maps/api';
import { Instance } from 'mobx-state-tree';
import { NavLink } from 'react-router-dom';
import { Page, TLCode } from '../../common/enums';
import TranslatedMessage from './translation/TranslatedMessage';
import { Button } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { Pharmacy } from '../../store/models/Pharmacy';
import { Protection } from '../../store/models/Protection';
import { IconNames } from '@blueprintjs/icons';
import SimplePharmacyCalendar from './calendar/SimplePharmacyCalendar';
import moment from 'moment';
import { Group } from '../../store/models/Group';
import { inject } from 'mobx-react';
import { PharmacyStatusStore, AuthenticationStore, GroupStore } from '../../store';
import withTranslate, { WithTranslateProps } from './WithTranslate';
import { PHARMACY_STATUS_TC } from '../../common/constants/pharmacyStatusConstants';

export interface ProtectionMarkerProps extends WithTranslateProps {
  protection: Instance<typeof Protection>;
  pharmacy: Instance<typeof Pharmacy>;
  icon: any;
  zIndex?: number;
  onSelectionClick?: (pharmacy: Instance<typeof Pharmacy>) => void;
  // onAssignClick?: (dutyAssignmentId: number, pharmacyId: number, type: string) => void;
  // onUnassignClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  //isFree?: (pharmacyId: number) => boolean;
  //isDayOnly?: (pharmacyId: number) => boolean;
  //isDayAndNight?: (pharmacyId: number) => boolean;
  //onAddDayOnlyClick?: (date: string, pharmacyId: number) => void;
  //onAddDayNightClick?: (date: string, pharmacyId: number) => void;
  //onChangeDayOnlyToDayNightClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  //onChangeDayNightToDayOnlyClick?: (dutyAssignmentId: number, pharmacyId: number) => void;
  //onMarkForGroupChangeClick?: (pharmacyId: number) => void;
  //onCalendarChanged?: (pharmacyId: number) => void;
  //onTogglePairingAllowedClick?: (pharmacyNeighborId: number) => void;
  //onToggleExchangeAllowedClick?: (pharmacyNeighborId: number) => void;
  onTerminateProtectionClick?: (protectionId: number) => void;
  pharmacyNeighborId?: number;
  onAddCircle?: (lat: number, long: number) => void;
  id?: number;
  date?: string;
  groupEditMode?: boolean;
  protections?: any;
  disableRightClick?: boolean;
  group?: Instance<typeof Group>;
  simpleCalendarStartYear?: number;
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  dutiesassignmentsList: any;
  showDutiesCountInDescription?: boolean | undefined;
  addOrRemoveMaskedPharmaciesProctectionCircles?: (apbNumber: number) => void;
  isMaskedPharmaciesProctectionCircles?: boolean;
}

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export interface ProtectionMarkerState {
  isOpen: boolean;
  isPinned: boolean;
  showContextMenu: boolean;
  //groupEditMode: boolean;
  //dutiesCountForPharmacy: number | undefined;
  //dayDutiesCountForPharmacy: number | undefined;
  //nightDutiesCountForPharmacy: number | undefined;
}

@inject('PharmacyStatusStore', 'AuthenticationStore')
class ProtectionMarker extends React.Component<ProtectionMarkerProps, ProtectionMarkerState> {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isPinned: false,
      showContextMenu: false,
      //groupEditMode: this.props.groupEditMode ? this.props.groupEditMode! : false,
      //dutiesCountForPharmacy: undefined,
      //dayDutiesCountForPharmacy: undefined,
      //nightDutiesCountForPharmacy: undefined,
    };
  }

  handleToggle = () => {
    this.setState({
      isOpen: false,
      isPinned: false,
    });
  };

  handleTogglePinned = () => {
    this.setState({
      isPinned: !this.state.isPinned,
      isOpen: !this.state.isPinned,
    });
  };

  handleToggleContextMenu = () => {
    this.setState({ showContextMenu: !this.state.showContextMenu });
  };

  render() {
    const { id } = this.props;
    //console.log(this.props.pharmacy.apbNumber);
    return (
      <>
        {id && (
          <Marker
            key={this.props.protection.protectionId}
            position={{ lat: Number(this.props.protection.latitude), lng: Number(this.props.protection.longitude) }}
            icon={this.props.icon}
            onClick={() => this.handleTogglePinned()}
            onRightClick={() => {
              if (!this.props.disableRightClick) this.handleToggleContextMenu();
            }}
            onMouseOver={() => {
              this.setState({
                isOpen: true,
              });
            }}
            onMouseOut={() =>
              this.setState({
                isOpen: false,
              })
            }
            zIndex={this.props.zIndex}
          >
            {(this.state.isOpen || this.state.isPinned) && (
              <InfoWindow onCloseClick={this.handleToggle} options={{ disableAutoPan: true }}>
                <div>
                  <DivLine>
                    <NavLink to={Page.PharmacyPage + '/' + this.props.protection.pharmacyId}>
                      <h4>
                        {this.props.pharmacy.apbNumber} - {this.props.pharmacy.name}
                      </h4>
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </DivLine>
                  <DivLine style={{ marginTop: '10px' }}>
                    {moment(this.props.protection.endDate).format('DD/MM/YYYY') + '  ' + this.props.protection.range + 'm'}
                  </DivLine>
                  <div style={{ marginTop: '15px' }}>
                    {this.props.onSelectionClick && (
                      <Button
                        onClick={() => {
                          this.props.onSelectionClick!(this.props.pharmacy);
                          this.handleTogglePinned();
                        }}
                        intent="primary"
                      >
                        {/* {this.state.selectButtonLabel} */}
                        <TranslatedMessage id={TLCode.GENERAL_Select} />
                      </Button>
                    )}
                  </div>
                  {this.props.onAddCircle && (
                    <DivLine
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '10px',
                      }}
                    >
                      <Button
                        style={{ fontSize: 12, marginLeft: '10px', marginRight: '10px' }}
                        onClick={() => {
                          if (this.props.onAddCircle) {
                            this.props.onAddCircle(
                              Number(this.props.protection.latitude),
                              Number(this.props.protection.longitude),
                            );
                            this.handleTogglePinned();
                          }
                        }}
                      >
                        <TranslatedMessage id={TLCode.TRANSFER_AddCircleDialogTitle} />
                      </Button>
                      {this.props.protections && this.props.protections.length > 0 && (
                        <Button
                          style={{ fontSize: 12, marginLeft: '10px', marginRight: '10px' }}
                          onClick={() => {
                            this.props.addOrRemoveMaskedPharmaciesProctectionCircles!(this.props.pharmacy.apbNumber);
                          }}
                        >
                          <TranslatedMessage id={this.props.isMaskedPharmaciesProctectionCircles ? TLCode.TRANSFER_ShowCircleDialogTitle : TLCode.TRANSFER_RemoveCircleDialogTitle} />
                        </Button>
                      )}
                    </DivLine>
                  )}
                </div>
              </InfoWindow>
            )}
          </Marker>
        )}
      </>
    );
  }
}

export default withTranslate(ProtectionMarker);
